import gql from "graphql-tag";

// eslint-disable-next-line import/prefer-default-export
export const CANCEL_SUBSCRIPTION = gql`
  mutation cancelPlan($data: CancelPlanInput!) {
    cancelPlan(data: $data) {
      data
    }
  }
`;